<div class="flex flex-col h-full mb-5">
    <h1 class="text-2xl">My Profile</h1>

    <div class="flex flex-col space-y-3 xl:flex-row xl:space-x-3 xl:space-y-0">
        <form
            [formGroup]="form"
            (submit)="submit()"
            class="bg-primary-50 rounded-lg py-5 px-7 w-full"
        >
            <div class="flex justify-between items-center mb-2">
                <h2 class="text-tertiary-900 !text-base font-medium !mb-0">
                    General Information
                </h2>

                <div class="flex items-center space-x-2">
                    <button
                        type="button"
                        mat-button
                        color="primary"
                        [routerLink]="cancelRoute"
                        class="text-base font-medium text-primary-700"
                    >
                        Cancel
                    </button>
                    <button
                        mat-flat-button
                        color="primary"
                        class="!rounded-full"
                        type="submit"
                    >
                        Save
                    </button>
                </div>
            </div>
            <div class="px-5 !text-base font-normal">
                <div class="flex flex-col 2xl:flex-row">
                    <mat-form-field
                        appearance="outline"
                        class="w-full flex md:w-96 2xl:w-72"
                    >
                        <mat-label>Company Address or PO box</mat-label>
                        <input
                            title="Company Address or PO box"
                            matInput
                            minlength="1"
                            maxlength="100"
                            [pattern]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            spellcheck="false"
                            formControlName="streetAddress"
                        />
                    </mat-form-field>

                    <div
                        class="flex flex-col lg:flex-row lg:justify-between lg:space-x-1 lg:w-96 2xl:ml-1"
                    >
                        <mat-form-field
                            appearance="outline"
                            class="w-full md:w-96 lg:w-96 xl:w-32"
                        >
                            <mat-label>City</mat-label>
                            <input
                                title="City"
                                matInput
                                minlength="3"
                                maxlength="50"
                                [pattern]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                                formControlName="city"
                            />
                        </mat-form-field>

                        <mat-form-field
                            appearance="outline"
                            class="w-full md:w-96 lg:w-96 xl:w-32"
                        >
                            <mat-label>State</mat-label>
                            <mat-select formControlName="stateProvinceId">
                                @for (
                                    stateProvince of stateProvinces;
                                    track stateProvince.id
                                ) {
                                    <mat-option value="{{ stateProvince.id }}">
                                        {{ stateProvince.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field
                            appearance="outline"
                            class="w-full md:w-96 lg:w-96 xl:w-32"
                        >
                            <mat-label>ZIP Code</mat-label>
                            <input
                                title="ZIP code"
                                matInput
                                [pattern]="regExPattern.MaskedPostalCode"
                                [imask]="maskOptions.postalCode"
                                [unmask]="false"
                                formControlName="postalCode"
                            />
                        </mat-form-field>
                    </div>
                </div>
                <section>
                    <mat-form-field appearance="outline" class="w-full md:w-96">
                        <mat-label>Job Title</mat-label>
                        <input
                            title="Job title"
                            matInput
                            minlength="3"
                            maxlength="50"
                            [pattern]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            formControlName="jobTitle"
                        />
                    </mat-form-field>
                </section>
                <section>
                    <mat-form-field appearance="outline" class="w-full md:w-96">
                        <mat-label>Direct Phone Number</mat-label>
                        <input
                            title="Direct phone number"
                            class=""
                            type="tel"
                            [showMaskTyped]="true"
                            [specialCharacters]="
                                phoneConstants.SPECIAL_CHARACTERS_WITH_EXTENSION
                            "
                            [dropSpecialCharacters]="
                                phoneConstants.DROP_SPECIAL_CHARACTERS_WITH_EXTENSION
                            "
                            placeHolderCharacter="_"
                            [shownMaskExpression]="
                                phoneConstants.SHOWN_MASK_EXPRESSION_WITH_EXTENSION
                            "
                            [mask]="phoneConstants.MASK_WITH_EXTENSION"
                            matInput
                            formControlName="phoneNumber"
                        />
                    </mat-form-field>
                </section>

                <button
                    type="button"
                    mat-flat-button
                    color="primary"
                    class="bg-primary-700 rounded-sm w-full md:w-96"
                    (click)="triggerPasswordReset()"
                    [disabled]="passwordResetTriggered"
                >
                    <span class="text-2xl font-normal">Change Password</span>
                </button>
            </div>
            <div class="flex flex-col space-y-2 mt-5">
                <div class="flex space-x-2">
                    <h3 class="!mb-0">Organization</h3>
                    <img
                        [matTooltipPosition]="'right'"
                        matTooltip="To edit this information please reach out to your Spectrum Advisor."
                        src="assets/svg/question-tooltip.svg"
                        alt="question mark"
                        class="!fill-primary-700 cursor-pointer"
                    />
                </div>

                <p>{{ organization?.name }}</p>
            </div>
        </form>

        <div class="flex flex-col space-y-5">
            @if (canManageAvailability && userId !== undefined) {
                <app-user-availability
                    [userId]="userId"
                ></app-user-availability>
            } @else {
                <app-spectrum-advisor-info
                    [advisorContact]="advisorContact"
                ></app-spectrum-advisor-info>
            }

            @if (canAccessPayments) {
                <app-cards-on-file />
            }
        </div>
    </div>
</div>
